import { Ban, ShieldAlert, Wrench, Eye, ShieldCheck } from "lucide-react";

function Card({ icon: Icon, label, value, sub, tone, testId }) {
    return (
        <div className={`rounded-xl p-4 border border-border shadow-sm border-l-4 ${tone}`} data-testid={testId}>
            <div className="flex items-center justify-between">
                <div className="text-[11px] uppercase tracking-wider text-muted-foreground">{label}</div>
                <Icon className="h-4 w-4 text-muted-foreground" />
            </div>
            <div className="text-2xl font-semibold text-gray-900 mt-1" data-testid={`${testId}-value`}>
                {(value ?? 0).toLocaleString()}
            </div>
            {sub ? <div className="text-xs text-muted-foreground mt-0.5">{sub}</div> : null}
        </div>
    );
}

export function SuppressionSummary({ data }) {
    const b = data.blocking_list;
    const live = data.live_captures || {};
    return (
        <div className="space-y-3" data-testid="suppression-summary">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
                <Card testId="card-blocking-list" icon={ShieldAlert} tone="border-l-rose-500 bg-rose-50/40"
                      label="Blocking list" value={b.total}
                      sub={`${b.marketing_dnc.toLocaleString()} Marketing DNC · ${b.technical.toLocaleString()} Technical`} />
                <Card testId="card-manual-review" icon={Eye} tone="border-l-slate-500 bg-slate-50/40"
                      label="Manual review (not blocked)" value={data.manual_review.total}
                      sub="On the list for review only. Sends are allowed." />
                <Card testId="card-prevented-sends" icon={ShieldCheck} tone="border-l-emerald-500 bg-emerald-50/40"
                      label="Actual prevented sends" value={data.prevented_sends.total}
                      sub={`Campaign SMS stopped before Twilio · ${data.range.start} to ${data.range.end}`} />
            </div>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-3 text-xs">
                <Mini icon={Ban} testId="mini-dnc" label="Marketing DNC" value={b.marketing_dnc} live={live.marketing_dnc} />
                <Mini icon={Wrench} testId="mini-technical" label="Technical" value={b.technical} live={live.technical} />
                <Mini icon={Eye} testId="mini-manual" label="Manual review" value={data.manual_review.total} live={live.manual_review} />
                <Mini icon={ShieldAlert} testId="mini-total" label="List total" value={data.list_total} />
            </div>
        </div>
    );
}

function Mini({ icon: Icon, label, value, live, testId }) {
    return (
        <div className="rounded-lg border border-border bg-white px-3 py-2 flex items-center gap-2" data-testid={testId}>
            <Icon className="h-3.5 w-3.5 text-muted-foreground" />
            <span className="text-muted-foreground">{label}</span>
            <span className="ml-auto font-semibold text-gray-900">{(value ?? 0).toLocaleString()}</span>
            {live !== undefined ? <span className="text-[10px] text-muted-foreground">({live} live)</span> : null}
        </div>
    );
}
